module.exports = __webpack_public_path__ + "img/mirna-anzaldo.f4201eaa.jpg";